export const isExternalLink = (link: string): boolean => link.startsWith('http');
